<template>
	<div class="v5-pull" @touchstart="touchStart" @touchmove="touchMove" @touchend="touchEnd" @touchcancel="touchCancel" :style="{ 'transform': transform}">
		<slot name="top">
			<div class="v5-pull-top" :style="{'height':`${height}px`,'top':`-${height}px`}">
				<slot name="loader">
					<div class="loader-wrap" :class="[status]">
						<div class="loader" :style="{'transform':`scale(${scale})`}">
						</div>
					</div>
				</slot>
				<p class="loader-text">{{text}}</p>
			</div>
		</slot>
		<slot></slot>
	</div>
</template>
<script>
	export default {
		name: 'v5-pull',
		props: {
			pullText: {
				type: String,
				default: '下拉刷新'
			},
			dropText: {
				type: String,
				default: '释放更新'
			},
			loadingText: {
				type: String,
				default: '正在更新'
			},
			doneText: {
				type: String,
				default: '更新成功'
			},
			failText: {
				type: String,
				default: '更新失败'
			},
			threshold: { //pull/drop状态切换临界值
				type: Number,
				default: 100
			},
			height: {
				type: Number,
				default: 80
			},
			zoom: { //滑动减速
				type: Number,
				default: 0.5
			}
		},
		computed: {
			transform() {
				return this.translate === 0 ? null : 'translate3d(0, ' + this.translate + 'px, 0)';
			},
			scale() {
				if (this.status === 'pull' || this.status === 'drop') {
					let tt = this.translate / this.threshold;
					if (tt <= 0.1) {
						return 0.1;
					}
					if (tt >= 1) {
						return 1;
					}
					return tt;
				}

			}
		},
		watch: {
			status(val) {
				switch (val) {
					case 'pull':
						this.text = this.pullText;
						break;
					case 'drop':
						this.text = this.dropText;
						break;
					case 'loading':
						this.text = this.loadingText;
						break;
					case 'done':
						this.text = this.doneText;
						break;
					case 'fail':
						this.text = this.failText;
						break;
				}
				this.$emit('on-update', val);
			}
		},
		methods: {
			touchStart(event) {
				this.startScrollTop = this.getScrollTop(this.scrollEventTarget);
				this.startY = event.touches[0].clientY;
				this.startTranslate = this.translate;
			},
			touchMove(event) {
				if (this.startY < this.$el.getBoundingClientRect().top && this.startY > this.$el.getBoundingClientRect().bottom) {
					return;
				}
				this.currentY = event.touches[0].clientY;
				this.distance = (this.currentY - this.startY) * this.zoom;

				if (this.startScrollTop === 0 && this.distance > 0) {
					event.preventDefault();
					event.stopPropagation();
					this.translate = this.distance + this.startTranslate;
					if (this.status !== 'loading') {
						this.status = this.translate > this.threshold ? 'drop' : 'pull';
					}
				}
			},
			touchEnd(event) {
				if (this.startScrollTop !== 0 || this.translate <= 0) {
					return;
				}
				//松手时下拉距离没有达到临界距离，则不触发更新操作
				if (this.status === 'pull') {
					this.translate = 0;
					return;
				}
				this.translate = this.height;

				//更新中不触发更新操作
				if (this.status !== 'loading') {
					this.status = 'loading';
					this.$emit('on-load');
				}
			},
			touchCancel(event) {
				this.translate = 0;
			},
			getScrollEventTarget(element) {
				let currentNode = element;
				while (currentNode && currentNode.tagName !== 'HTML' &&
					currentNode.tagName !== 'BODY' && currentNode.nodeType === 1) {
					let overflowY = document.defaultView.getComputedStyle(currentNode).overflowY;
					if (overflowY === 'scroll' || overflowY === 'auto') {
						return currentNode;
					}
					currentNode = currentNode.parentNode;
				}
				return window;
			},
			getScrollTop(element) {
				if (element === window) {
					return Math.max(window.pageYOffset || 0, document.documentElement.scrollTop);
				} else {
					return element.scrollTop;
				}
			},
			complete(type = true) {
				this.status = type ? 'done' : 'fail';
				setTimeout(() => {
					//只有成功状态时进行reset
					if (this.status === 'done' || this.status === 'fail') {
						this.translate = 0;
					}
				}, 1000);
			}
		},
		data() {
			return {
				translate: 0,
				startTranslate: 0,
				startScrollTop: 0,
				scrollEventTarget: null,
				text: '',
				status: ''
			};
		},
		mounted() {
			this.scrollEventTarget = this.getScrollEventTarget(this.$el);
		}
	};

</script>
<style lang="scss" scoped>
	@import './style.scss';

</style>
